<template>
    <v-select
        v-model="sortKey"
        item-title="text"
        class="pt-3 px-3"
        density="compact"
        variant="underlined"
        :items="items"
        :label="$t('sort.sort')"
    >
        <template v-slot:selection="{item}">
            <span class="text-caption">
                {{ item.title }}
            </span>
        </template>
    </v-select>
</template>

<script lang="ts">
    import {Component, Prop, VModel, Vue} from 'vue-facing-decorator'

    @Component
    export class SortSelect extends Vue {
        @VModel({required: true}) sortKey
        @Prop({required: true}) items
    }

    export default SortSelect
</script>

<style scoped>
    :deep(.v-select__selections) {
        font-size: 13px;
    }

    :deep(.v-list-item--link) {
        font-size: 12px;
    }
</style>
